import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import theme, { gradient } from '../utils/theme';
import ProgressButton from '../components/ProgressButton';

const useStyles = makeStyles((theme) => ({
  gradient: {
    height: '30px',
    background: theme.palette.secondary.main,
  },
  button: {
    margin: theme.spacing(1),
  },
}));

export default function ConfirmModal(props) {
  const { visible, title, message, onYes, onNo, yesDisabled, confirmText, cancelText } = props;

  const classes = useStyles();
  const [confirming, setConfirming] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [confirmButtonText, setConfirmButtonText] = useState();
  const [cancelButtonText, setCancelButtonText] = useState();

  useEffect(() => {
    async function onLoad() {
      setConfirmButtonText(confirmText ? confirmText : 'Confirm');
      setCancelButtonText(cancelText ? cancelText : 'Cancel');
    }
    onLoad();
  }, [confirmText, cancelText]);

  async function doConfirm() {
    setConfirming(true);
    await onYes();
    setConfirming(false);
  }

  async function doCancel() {
    setCancelling(true);
    await onNo();
    setCancelling(false);
  }

  async function onClose(event, reason) {
    if (reason === 'escapeKeyDown') {
      await doCancel();
    }
  }

  return (<>
    <Dialog open={visible} onClose={onClose}>
      <div className={classes.gradient} />
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent>
        {message}
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent='flex-end'>
          {onNo && (
            <Grid item>
              <ProgressButton
                className={classes.button}
                color='primary'
                variant='outlined'
                disabled={confirming || cancelling}
                onClick={doCancel}
                loading={cancelling}
                type='submit'
                success={false}
              >
                {cancelButtonText}
              </ProgressButton>
            </Grid>
          )}
          {onYes && (
            <Grid item>
              <ProgressButton
                className={classes.button}
                color='primary'
                disabled={confirming || cancelling || yesDisabled}
                onClick={doConfirm}
                loading={confirming}
                type='submit'
                success={false}
              >
                {confirmButtonText}
              </ProgressButton>
            </Grid>
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  </>);
}
